import { render, staticRenderFns } from "./SelectBarang.vue?vue&type=template&id=4e339a18"
import script from "./SelectBarang.vue?vue&type=script&lang=js"
export * from "./SelectBarang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports